import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { installTranslateGuard } from './lib/translate-guard'

// Evita crashes de React cuando el traductor del navegador (Chrome/Safari)
// modifica el DOM por debajo del Virtual DOM.
installTranslateGuard();

createRoot(document.getElementById("root")!).render(<App />);
